const RELATIONS = ["===", "!==", "==", "!=", ">=", "<=", ">", "<"];

export const QUANTITY_RELATIONS = RELATIONS;

function scanTopLevel(source, visitor) {
  let depth = 0;
  let quote = null;
  let escaped = false;

  for (let index = 0; index < source.length; index += 1) {
    const character = source[index];
    if (quote) {
      if (escaped) escaped = false;
      else if (character === "\\") escaped = true;
      else if (character === quote) quote = null;
      continue;
    }
    if (character === '"' || character === "'") {
      quote = character;
      continue;
    }
    if (["(", "[", "{"].includes(character)) depth += 1;
    else if (")]}".includes(character)) depth -= 1;
    else if (depth === 0 && visitor(character, index) === false) return index;
  }
  return -1;
}

export function stripOuterParentheses(value) {
  let source = String(value ?? "").trim();
  let changed = true;
  while (changed && source.startsWith("(") && source.endsWith(")")) {
    // A setting token's parentheses are part of its syntax, not grouping.
    if (/^\(\*\d+(?:@\d+)?(?:\.(?:cur|sum|len|idx|idx0|bef\.sum|aft\.sum))?\*\)$/.test(source)) break;
    changed = false;
    let depth = 0;
    let closesAtEnd = false;
    for (let index = 0; index < source.length; index += 1) {
      if (source[index] === "(") depth += 1;
      else if (source[index] === ")") depth -= 1;
      if (depth === 0) {
        closesAtEnd = index === source.length - 1;
        break;
      }
    }
    if (closesAtEnd) {
      source = source.slice(1, -1).trim();
      changed = true;
    }
  }
  return source;
}

function splitCondition(condition) {
  const source = stripOuterParentheses(condition);
  let match = null;
  scanTopLevel(source, (_, index) => {
    const relation = RELATIONS.find((candidate) =>
      source.startsWith(candidate, index)
    );
    if (!relation) return true;
    match = {
      left: source.slice(0, index).trim(),
      relation,
      right: source.slice(index + relation.length).trim()
    };
    return false;
  });
  return match || { left: source, relation: "==", right: '"Igen"' };
}

export function splitConditionalExpression(value) {
  const source = stripOuterParentheses(value);
  let questionIndex = -1;
  scanTopLevel(source, (character, index) => {
    if (character !== "?") return true;
    questionIndex = index;
    return false;
  });
  if (questionIndex < 0) return null;

  let nestedQuestions = 0;
  let colonIndex = -1;
  scanTopLevel(source.slice(questionIndex + 1), (character, relativeIndex) => {
    if (character === "?") nestedQuestions += 1;
    if (character !== ":") return true;
    if (nestedQuestions > 0) {
      nestedQuestions -= 1;
      return true;
    }
    colonIndex = questionIndex + 1 + relativeIndex;
    return false;
  });
  if (colonIndex < 0) return null;

  return {
    condition: source.slice(0, questionIndex).trim(),
    whenTrue: stripOuterParentheses(
      source.slice(questionIndex + 1, colonIndex)
    ),
    whenFalse: stripOuterParentheses(source.slice(colonIndex + 1))
  };
}

export function parseQuantityConditional(value) {
  const parsed = splitConditionalExpression(value);
  return parsed ? { ...splitCondition(parsed.condition), whenTrue: parsed.whenTrue, whenFalse: parsed.whenFalse } : null;
}

export function compileQuantityConditional(rule) {
  const left = rule.left.trim() || "0";
  const right = rule.right.trim() || "0";
  const whenTrue = rule.whenTrue.trim() || "0";
  const whenFalse = rule.whenFalse.trim() || "0";
  return `(${left} ${rule.relation} ${right}) ? (${whenTrue}) : (${whenFalse})`;
}

export function appendQuantityToken(value, token) {
  const source = String(value ?? "");
  const needsSpace = source && !source.endsWith(" ") && !token.startsWith(")");
  return `${source}${needsSpace ? " " : ""}${token}`;
}
